import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import LoaderModal from '../../../../modal/LoaderModal';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import {Row, Col, Alert, Table} from 'react-bootstrap';
import './circlebar.css';
import './reportsbmptn.css';
import { TableHead, TableRow, TableCell, TableBody, Grid, Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

class MonitoringStatusPengerjaan extends Component {
    constructor(props) {
        super(props);
        this.state = {              
            isFetching: true,
            listMapel: [],
            detailSiswa: [],
            listSiswa: [],
            detailKelasParalel: [],
            data: {},
            progres: 0,
            detikRefresh: 30
        }
        
        
    }

    async componentDidMount(){
        this.setState({ isFetching : false });
        await this.props.cekCookies();
        if(this.props.history.location.state !== undefined){

            console.groupCollapsed('MINITORING SISWA');
            console.log(this.props);
            console.log(this.props.history.location.state.data.kodeTa);
            console.log(this.props.history.location.state.data.idJadwal);
            console.log(this.props.history.location.state.data.idKp);
            console.log(this.props.history.location.state.data.kodeAspek);
            console.groupEnd();

            this.setState({ data : this.props.history.location.state.data });
            const prog = this.state.progres;
            setInterval(async() => { 
                this.setState({ progres: this.state.progres + (100 / this.state.detikRefresh) });
                if(this.state.progres > 100){
                    this.setState({ progres: 0});
                    this.fetchMonitoring();
                } 
            }, 1000);

            this.fetchMonitoring();
        }else{
            this.setState({ isFetching : false });

        }
        
    }


    async fetchMonitoring (){
        const {data} = this.state;

        if(data.kodeAspek === '' && data.kodeSubTipe === 'AGCU'){                                                                      // LIVE REPORT AGCU
            const response = await accountManagement.get(CONFIG.REPORT_CBT_LIST_MONITORING_SISWA, {
                params: { tahunAjaran: data.kodeTa, 
                    idJadwalCbt: data.idJadwal,
                    idKelasParalel: data.idKp
                }
            }).catch(function(error){});
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listMapel: response.data.data.listMapel,
                        detailSiswa: response.data.data.detailSiswa,
                        detailKelasParalel: response.data.data.detailKelasParalel
                    })
                }
                this.setState({ 
                    isFetching: false,
                    progres: 0
                })
            }
        }else if(data.kodeAspek === 'TA'){                                                                  // LIVE REPORT STA
            const response = await accountManagement.get(CONFIG.REPORT_CBT_STA_LIVE_LIST_SISWA, {
                params: { tahunAjaran: data.kodeTa, 
                    idJadwalCbt: data.idJadwal,
                    idKelasParalel: data.idKp
                }
            }).catch(function(error){});
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listSiswa: response.data.data.listSiswa,
                        detailKelasParalel: response.data.data.detailKelasParalel,
                    })
                }
                this.setState({ 
                    isFetching: false,
                    progres: 0
                })
            }
        }

        // SET TITTLE 
        document.title = "Live "+ this.props.account.namaUser +"-"+ this.state.detailKelasParalel.namaKelasParalel
    }

    render() { 
        const {data, detailKelasParalel, progres, isFetching} = this.state;
        return (
            <div id="container-fluid" style={{padding: '10px'}}>
                {isFetching ?
                    <LoaderModal isFetching={isFetching} />          
                    
                :
                    <Grid container spacing={2}>
                        <Grid item xs={12} align="center">
                            <Typography variant="h5" color="textPrimary" align="center" style={{fontWeight: 700}}>
                            LIVE REPORT {data.kodeAspek === 'TA' ? 'TALENT ANALYSIS' : 'AGCU'}
                            </Typography>
                            <Typography variant="h6" color="textPrimary" align="center" style={{fontWeight: 700}}>
                                {this.props.account.namaUser} - {detailKelasParalel.namaKelasParalel}
                            </Typography>
                        </Grid> 

                        <Grid item xs={12}>
                            <LinearProgress variant="determinate" value={progres} />
                        </Grid> 


                        {/* KONTEN TABEL */}
                        <Grid item xs={12}>
                            {
                                data.kodeAspek === 'TA' ? 
                                    this.renderSiswaTa()
                                : 
                                    this.renderSiswaAgcu()
                            }
                        </Grid>
                    </Grid>
                }
                
            </div>
        );
    }

    renderSiswaAgcu(){
        const {listMapel, detailSiswa} = this.state;
        return(
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th rowSpan="2">No</th>
                        <th rowSpan="2">Nama Siswa</th>
                        <th className="text-center" colSpan={listMapel.length}>MATA PELAJARAN</th>
                        <th className="text-center" rowSpan="2">LS</th>
                        <th className="text-center" rowSpan="2">PSI</th>
                    </tr>
                    <tr>
                        {
                            listMapel.map((val, i) =>
                                <th className="text-center">{val.namaMataPelajaran}</th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        detailSiswa.map((val, i)=>
                            <tr>
                                <td>{i+1}</td>
                                <td>{val.namaSiswa}</td>
                                {
                                    val.detailSkor.map((valSkor, i)=>
                                        <td className="text-center">{valSkor.skor}</td>
                                    )
                                }
                                {
                                    val.detailSkorNon.map((valSkorNon, i)=>
                                        <td className="text-center">{valSkorNon.skor !== '-' ? <CheckCircleOutlineIcon color="primary" /> : <HighlightOffIcon color="secondary"/>}</td>
                                    )
                                }
                            </tr>
                        )
                    }
                </tbody>
            </table>
        )
    }

    renderSiswaTa(){
        const {listSiswa, detailKelasParalel} = this.state;
        return(
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Nama Siswa</th>
                        <th className="text-center">Stage 1</th>
                        <th className="text-center">Stage 2</th>
                        <th className="text-center">Stage 3</th>
                        <th className="text-center">Stage 4</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listSiswa.map((val, i)=>
                            <tr>
                                <td>{i+1}</td>
                                <td>{val.namaSiswa}</td>
                                {
                                    val.detailPengerjaan.map((valSkor, i)=>
                                        <td className="text-center">
                                            {
                                                valSkor.statusAgcu > 0 ? <CheckCircleOutlineIcon color="primary" /> : <HighlightOffIcon color="secondary"/>
                                            }
                                        </td>
                                    )
                                }
                            </tr>
                        )
                    }
                </tbody>
            </table>
        )
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(MonitoringStatusPengerjaan); 
